const faqItems = [
  {
    q: '暗网吃瓜是什么？和普通娱乐网站有什么不同？',
    a: '暗网吃瓜是一个去中心化的黑料讨论和爆料交流社区，汇集了暗网吃瓜论坛和全国各地的吃瓜群。不同于传统娱乐网站的单向推送，暗网吃瓜强调用户驱动的真实吃瓜体验——所有内容来自匿名爆料人和吃瓜群众的交叉验证，确保信息的真实性和深度。',
  },
  {
    q: '如何在暗网吃瓜论坛发帖或参与黑料讨论？',
    a: '你可以在暗网吃瓜论坛注册账号后自由发帖，参与任何你感兴趣的黑料讨论。对于爆料内容，我们建议提供尽可能多的佐证材料。所有帖子发布前都会经过社区审核团队的快速验证，既保护爆料人隐私，又确保内容质量。',
  },
  {
    q: '暗网吃瓜群的加入方式是什么？',
    a: '目前暗网吃瓜群采用邀请制与开放申请相结合的方式。你可以在论坛活跃一段时间后获得群邀请，或通过投稿高质量的新爆料来申请加入。我们覆盖全国300+城市的吃瓜群，确保你总能找到志同道合的吃瓜伙伴。',
  },
  {
    q: '爆料的真实性和隐私如何保障？',
    a: '暗网吃瓜采用多重机制保障信息质量和用户隐私。所有爆料帖经社区交叉验证后标记可信度等级；匿名爆料人的身份信息采用端到端加密存储，即使是平台运营方也无法查看原始身份。同时我们建立了快速辟谣通道，一旦内容被证实不实，立即标注并推送更正。',
  },
  {
    q: '新爆料多久能出现在暗网吃瓜上？',
    a: '暗网吃瓜以"吃瓜速递"著称。从用户提交新爆料到社区可见，平均审核时间不到30分钟。对于重大突发事件，我们的7×24小时审核团队可在5分钟内完成验证并推送到首页。这也是为什么暗网吃瓜总能成为全网第一手真实的吃瓜信息来源。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            常见问题
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-200 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-400 text-xs font-bold">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-sm md:text-base font-bold text-foreground-200 mb-2">
                    {item.q}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}